import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

/* THUNKS & SELECTORS */
import { fetchParticipants, addParticipant, updateParticipant, exportParticipantsThunk, downloadReceiptThunk } from "../../redux/admin/tournamentParticipants.thunk";
import { fetchTournaments } from "../../redux/admin/tournaments.thunk";
import { selectTournamentList, selectCategoriesByTournament } from "../../redux/admin/tournaments.selector";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

const TournamentParticipants = () => {
  const dispatch = useDispatch();

  /* ================= STATE ================= */
  const {
    participants = [],
    meta = { page: 1, total_pages: 1, total: 0 },
    loading = false,
  } = useSelector((state) => state.admin?.tournamentParticipants || {});

  const tournaments = useSelector(selectTournamentList);
  const [tournamentId, setTournamentId] = useState("");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const categories = useSelector(selectCategoriesByTournament(tournamentId)) || [];
  const selectedTournament = tournaments.find(t => String(t.id) === String(tournamentId));
console.log(selectedTournament);
  const [contact, setContact] = useState({ contact_name: "", contact_phone: "", contact_email: "" });
  const [payment, setPayment] = useState({
  payment_mode: "",
  total_amount: 0
});
  const initialPlayer = {
  player_name: "",
  dob: "",
  category: "",
  gender: "Male",
entry_fee: Number(selectedTournament?.entry_fee || 0),
additional_fee: Number(selectedTournament?.additional_fee || 0),
additional_label: selectedTournament?.additional_fee_label || "Fee",
total_fee:
  Number(selectedTournament?.entry_fee || 0) +
  Number(selectedTournament?.additional_fee || 0),
  cdca_id: "",
  tnsca_id: "",
  fide_id: ""
};
  const [players, setPlayers] = useState([initialPlayer]);

  /* ================= EFFECTS ================= */
  useEffect(() => { dispatch(fetchTournaments()); }, [dispatch]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search), 400);
    return () => clearTimeout(t);
  }, [search]);

  const loadData = useCallback((page = 1) => {
    if (!tournamentId) return;
    dispatch(fetchParticipants({ tournament_id: tournamentId, page, limit: 12, search: debouncedSearch }));
  }, [dispatch, tournamentId, debouncedSearch]);

  useEffect(() => { loadData(1); }, [loadData]);

  /* ================= HANDLERS ================= */
  const handlePageChange = (p) => { if (p >= 1 && p <= meta.total_pages) loadData(p); };

  const handleAddPlayer = () => setPlayers([
  ...players,
  {
    ...initialPlayer,
    entry_fee: selectedTournament?.entry_fee || 0,
    additional_fee: selectedTournament?.additional_fee || 0,
    total_fee:
      (selectedTournament?.entry_fees || 0) +
      (selectedTournament?.additional_fee || 0),
  },
]);
  
const calculateFees = (player) => {
  const entry = Number(player.entry_fee || 0);

  let additional = Number(player.additional_fee || 0);

  // CDCA logic
  if (player.cdca_id && player.cdca_id.trim() !== "") {
    additional = 0;
  }

  return {
    ...player,
    entry_fee: entry,
    additional_fee: additional,
    total_fee: entry + additional,
  };
};

  const handleRemovePlayer = (index) => {
    setPlayers(prev => prev.filter((_, i) => i !== index));
  };

  const openAddModal = () => {
    if (!tournamentId) return toastr.warning("Please select a tournament first");
    setIsEditMode(false);
    setPlayers([{ ...initialPlayer }]);
    setContact({ contact_name: "", contact_phone: "", contact_email: "" });
    setShowModal(true);
  };

const openEditModal = (p) => {
  console.log("EDIT DATA:", p);
  setEditId(p.id);
  setIsEditMode(true);

  // ✅ CONTACT
  setContact({
    contact_name: p.contact_name || "",
    contact_phone: p.contact_phone || "",
    contact_email: p.contact_email || ""
  });

  // ✅ PAYMENT
  setPayment({
    payment_mode: p.payment_mode || "",
    total_amount: Number(p.total_amount || 0)
  });

  // ✅ PLAYER (FULL MAPPING)
  setPlayers([{
    player_name: p.player_name || "",
    dob: p.dob === "0000-00-00" ? "" : p.dob,
    category: p.category || "",
    gender: p.gender === "M" ? "Male" : "Female",

    entry_fee: Number(p.entry_fee || 0),
  additional_fee: Number(p.cdca_fee || p.additional_fee || 0),
    additional_label: selectedTournament?.additional_fee_label || "Fee",

    cdca_id: p.cdca_id || "",
    fide_id: p.fide_id || "",
    tnsca_id: p.tnsca_id || "",

    total_fee:
      Number(p.entry_fee || 0) +
      Number(p.additional_fee || 0),
  }]);

  setShowModal(true);
};

  const handleSubmit = async () => {
    try {
      const formattedPlayers = players.map(p => ({
  ...p,
  gender: p.gender === "Male" ? "M" : "F",
  fide_id: p.fide_id || null,
  tnsca_id: p.tnsca_id || null
}));

    //  const formattedPlayers = players.map(p => ({ ...p, gender: p.gender === "Male" ? "M" : "F" }));
      if (isEditMode) {
      //  await dispatch(updateParticipant({ ...formattedPlayers[0], ...contact })).unwrap();
        await dispatch(updateParticipant({
  id: editId,            // ✅ ADD THIS
  ...formattedPlayers[0],
  ...contact,
  ...payment
})).unwrap();
  setEditId(null);
        toastr.success("Record updated");
      
      } else {
        await dispatch(addParticipant({ tournament_id: tournamentId, ...contact, ...payment, players: formattedPlayers })).unwrap();
        toastr.success("Registration successful");
      }
      setShowModal(false);
      loadData(meta.page);
    } catch (err) { toastr.error(err || "Save failed"); }
  };

const handleDownloadExcel = async () => {
  if (!tournamentId) {
    return toastr.warning("Select tournament first");
  }

  try {
    const result = await dispatch(
      exportParticipantsThunk({ tournament_id: tournamentId })
    );

    if (exportParticipantsThunk.rejected.match(result)) {
      throw new Error(result.payload);
    }

    const blob = result.payload;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `${selectedTournament?.name || "Participants"}.xls`;

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    toastr.success("Download started");
  } catch (error) {
    toastr.error(error.message);
  }
};

const totalAmount = players.reduce((sum, p) => {
  const entry = Number(p.entry_fee || 0);
  const additional = p.cdca_id ? 0 : Number(p.additional_fee || 0);
  return sum + entry + additional;
}, 0);

useEffect(() => {
  const total = players.reduce((sum, p) => {
    const entry = Number(p.entry_fee || 0);
    const additional = p.cdca_id ? 0 : Number(p.additional_fee || 0);
    return sum + entry + additional;
  }, 0);

  setPayment(prev => ({ ...prev, total_amount: total }));
}, [players]);

const handleDownloadReceipt = async (participantId) => {
  try {
    const result = await dispatch(
      downloadReceiptThunk({ participant_id: participantId })
    );

    if (downloadReceiptThunk.rejected.match(result)) {
      throw new Error(result.payload);
    }

    const blob = result.payload;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    const receiptNo = `AADH-TRN-${new Date().getFullYear()}-${String(participantId).padStart(6, "0")}`;

a.download = `${receiptNo}.pdf`;


    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

  } catch (err) {
    toastr.error(err.message);
  }
};

  return (
    <div className="precise-app-bg">
      <div className="precise-card">
        {/* HEADER */}
        <header className="precise-header">
          <div className="title-area">
            <h1>Chess Participant Portal</h1>
            <p>2nd District Level Chess Tournament 2026</p>
          </div>
          <button className="btn-reg-main" onClick={openAddModal}>
            New Entry
          </button>

{/* DOWNLOAD EXCEL BUTTON */}

  <button
  className="btn-download"
  onClick={handleDownloadExcel}
>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" y1="15" x2="12" y2="3"></line>
      </svg>
      Export Excel
    </button>
        </header>

        {/* TOOLBAR */}
        <section className="precise-toolbar">
          <div className="search-wrapper">
            <input placeholder="Search records..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="filter-wrapper">
            <span className="label-tiny">Tournament:</span>
            <select value={tournamentId} onChange={(e) => setTournamentId(e.target.value)}>
              <option value="">Select Event...</option>
              {tournaments.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
        </section>

        {/* TABLE */}
        <div className="table-responsive">
          <table className="precise-table">
            <thead>
              <tr>
                <th>Participant</th>
                <th>Guardian / Contact</th>
                <th>Category</th>
                <th>Gender</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" className="state-msg">Syncing database...</td></tr>
              ) : !tournamentId ? (
                <tr><td colSpan="5" className="state-msg">Select a tournament to load data</td></tr>
              ) : participants.length === 0 ? (
                <tr><td colSpan="5" className="state-msg">No entries found for this selection</td></tr>
              ) : (
                participants.map((p) => (
                  <tr key={p.id}>
                    <td>
                      <div className="user-info">
                        <div className="user-icon">{p.player_name.charAt(0)}</div>
                        <div>
                           <span className="u-name">{p.player_name}</span>
                           <span className="u-dob">DOB: {p.dob}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="u-name">{p.contact_name || "—"}</span>
                      <span className="u-dob">{p.contact_phone || "No Phone"}</span>
                    </td>
                    <td><span className="cat-pill">{p.category}</span></td>
                    <td>{p.gender === 'M' ? 'Male' : 'Female'}</td>
                    <td style={{ textAlign: "right" }}>
                      <button className="btn-action-edit" onClick={() => openEditModal(p)}>Edit</button>
                      <button
  className="btn-download"
  onClick={() => handleDownloadReceipt(p.id)}
>
  Receipt
</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <footer className="precise-footer">
          <div className="stats">Showing {participants.length} of {meta.total}</div>
          <div className="pagination-group">
            <button className="btn-pg" disabled={meta.page <= 1} onClick={() => handlePageChange(meta.page - 1)}>Prev</button>
            <div className="pg-indicator">Page <span>{meta.page}</span> / {meta.total_pages || 1}</div>
            <button className="btn-pg" disabled={meta.page >= meta.total_pages} onClick={() => handlePageChange(meta.page + 1)}>Next</button>
          </div>
        </footer>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-meta">
                <span className="meta-tag">2026 District Level</span>
                <h2>{selectedTournament?.name}</h2>
              </div>
              <button className="btn-close" onClick={() => setShowModal(false)}>✕</button>
            </div>

            <div className="modal-body">
              <div className="form-section">
                <h4 className="sec-title">Contact Information</h4>
                <div className="grid-3">
                  <div className="fld-grp">
                    <label>Guardian Name</label>
                    <input value={contact.contact_name} onChange={(e) => setContact({...contact, contact_name: e.target.value})} />
                  </div>
                  <div className="fld-grp">
                    <label>Phone</label>
                    <input value={contact.contact_phone} onChange={(e) => setContact({...contact, contact_phone: e.target.value})} />
                  </div>
                  <div className="fld-grp">
                    <label>Email</label>
                    <input value={contact.contact_email} onChange={(e) => setContact({...contact, contact_email: e.target.value})} />
                  </div>
                </div>
              </div>

              <div className="form-section">
                <div className="sec-header">
                  <h4 className="sec-title">Player Details</h4>
                  {!isEditMode && <button className="btn-add-text" onClick={handleAddPlayer}>+ Add Player</button>}
                </div>
                {players.map((p, i) => (
                  <div key={i} className="player-card">
                    {!isEditMode && players.length > 1 && (
                      <button className="btn-del-player" onClick={() => handleRemovePlayer(i)}>Remove Player</button>
                    )}
                    <div className="grid-2">
                      <div className="fld-grp">
                        <label>Player Name</label>
                        <input value={p.player_name} onChange={(e) => {
                            const up = [...players]; up[i].player_name = e.target.value; setPlayers(up.map(calculateFees));;
                        }} />
                      </div>
                      <div className="fld-grp">
                        <label>Category</label>
                        <select value={p.category} onChange={(e) => {
                             const up = [...players]; up[i].category = e.target.value; setPlayers(up.map(calculateFees));;
                        }}>
                          <option value="">Select...</option>
                          {categories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                        </select>
                      </div>
                      <div className="fld-grp">
                        <label>DOB</label>
                        <input type="date" value={p.dob} onChange={(e) => {
                             const up = [...players]; up[i].dob = e.target.value; setPlayers(up.map(calculateFees));;
                        }} />
                      </div>
                      <div className="fld-grp">
                        <label>Gender</label>
                        <select value={p.gender} onChange={(e) => {
                             const up = [...players]; up[i].gender = e.target.value; setPlayers(up.map(calculateFees));;
                        }}>
                          <option>Male</option><option>Female</option>
                        </select>
                      </div>

                      <div className="fld-grp">
  <label>Entry Fee</label>
  <input
    type="number"
    value={p.entry_fee}
    onChange={(e) => {
      const up = [...players];
      up[i].entry_fee = e.target.value;
      setPlayers(up.map(calculateFees));
    }}
  />
</div>

<div className="fld-grp">
  <label>{p.additional_label}</label>
  <input
    type="number"
    value={p.cdca_id ? 0 : p.additional_fee}
    onChange={(e) => {
      const up = [...players];
      up[i].additional_fee = e.target.value;
      setPlayers(up.map(calculateFees));
    }}
  />
</div>

<div className="fld-grp">
  <label>{p.additional_label} ID</label>
  <input
    value={p.cdca_id}
    onChange={(e) => {
      const up = [...players];
      up[i].cdca_id = e.target.value;
      setPlayers(up.map(calculateFees));
    }}
    placeholder="Optional"
  />
</div>

<div className="fld-grp">
  <label>TNSCA ID</label>
  <input
    value={p.tnsca_id || ""}
    onChange={(e) => {
      const up = [...players];
      up[i].tnsca_id = e.target.value;
      setPlayers(up);
    }}
    placeholder="Optional"
  />
</div>

<div className="fld-grp">
  <label>FIDE ID</label>
  <input
    value={p.fide_id || ""}
    onChange={(e) => {
      const up = [...players];
      up[i].fide_id = e.target.value;
      setPlayers(up);
    }}
    placeholder="Optional"
  />
</div>


                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-footer">


<div className="payment-summary-card">

  {/* LEFT - TOTAL */}
  <div className="summary-left">
    <span className="summary-label">Total Amount</span>
    <span className="summary-value">
  ₹{players.reduce((sum, p) => {
  const entry = Number(p.entry_fee || 0);
  const additional = p.cdca_id ? 0 : Number(p.additional_fee || 0);
  return sum + entry + additional;
}, 0)}
    </span>
  </div>

  {/* RIGHT - PAYMENT */}
  <div className="summary-right">
    <label>Payment Mode</label>
    <select
     value={payment.payment_mode}
onChange={(e) =>
  setPayment({ ...payment, payment_mode: e.target.value })
}

    >
      <option value="">Select</option>
      <option value="cash">💵 Cash</option>
      <option value="upi">📱 UPI</option>
      <option value="online">🌐 Online</option>
    </select>
  </div>

</div>

              <button className="btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn-save" onClick={handleSubmit}>Save Registration</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .precise-app-bg { background: #f8fafc; min-height: 100vh; padding: 2rem 1rem; font-family: 'Inter', system-ui, sans-serif; }
        .precise-card { max-width: 1000px; margin: 0 auto; background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); overflow: hidden; }
        
        /* HEADER */
        .precise-header { padding: 1.5rem 2rem; display: flex; justify-content: space-between; align-items: center; background: #fff; border-bottom: 1px solid #f1f5f9; }
        .precise-header h1 { font-size: 1.1rem; font-weight: 800; color: #0f172a; margin: 0; }
        .precise-header p { font-size: 12px; color: #64748b; margin: 2px 0 0; }
        .btn-reg-main { background: #2563eb; color: #fff; border: none; padding: 10px 20px; border-radius: 8px; font-size: 13px; font-weight: 700; cursor: pointer; }

        /* TOOLBAR */
        .precise-toolbar { padding: 0.75rem 2rem; background: #fcfdfe; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
        .search-wrapper input { border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 12px; width: 280px; font-size: 12px; outline: none; transition: border 0.2s; }
        .search-wrapper input:focus { border-color: #2563eb; }
        .filter-wrapper { display: flex; align-items: center; gap: 8px; }
        .label-tiny { font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; }
        .filter-wrapper select { border: 1px solid #e2e8f0; border-radius: 6px; padding: 6px 10px; font-size: 12px; background: #fff; }

        /* TABLE */
        .precise-table { width: 100%; border-collapse: collapse; }
        .precise-table th { text-align: left; padding: 12px 2rem; font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; border-bottom: 1px solid #f1f5f9; }
        .precise-table td { padding: 12px 2rem; font-size: 13px; border-bottom: 1px solid #f8fafc; color: #334155; }
        .user-info { display: flex; align-items: center; gap: 12px; }
        .user-icon { width: 32px; height: 32px; background: #eff6ff; color: #2563eb; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 12px; }
        .u-name { display: block; font-weight: 600; color: #1e293b; }
        .u-dob { display: block; font-size: 11px; color: #94a3b8; }
        .cat-pill { background: #f1f5f9; padding: 3px 8px; border-radius: 6px; font-size: 11px; font-weight: 700; color: #475569; }
        .btn-action-edit { background: transparent; border: 1px solid #e2e8f0; padding: 5px 12px; border-radius: 6px; font-size: 11px; font-weight: 600; cursor: pointer; transition: background 0.2s; }
        .btn-action-edit:hover { background: #f8fafc; }

        /* FOOTER */
        .precise-footer { padding: 1.25rem 2rem; display: flex; justify-content: space-between; align-items: center; background: #fff; border-top: 1px solid #f1f5f9; }
        .stats { font-size: 12px; color: #64748b; font-weight: 500; }
        .pagination-group { display: flex; align-items: center; gap: 1rem; }
        .btn-pg { background: #fff; border: 1px solid #e2e8f0; padding: 6px 14px; border-radius: 8px; font-size: 12px; font-weight: 600; cursor: pointer; }
        .btn-pg:disabled { opacity: 0.5; cursor: default; }
        .pg-indicator { font-size: 12px; font-weight: 600; color: #64748b; }
        .pg-indicator span { color: #2563eb; }

        /* DOWNLOAD BUTTON - PRECISE DESIGN */
.btn-download {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  color: #16a34a; /* Success Green */
  border: 1px solid #dcfce7;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-download:hover {
  background: #f0fdf4;
  border-color: #16a34a;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-download:active {
  transform: translateY(0px);
  background: #dcfce7;
}

.btn-download svg {
  flex-shrink: 0;
}

/* Update toolbar to accommodate the new button */
.precise-toolbar .right-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.payment-summary-card {
  margin-top: 20px;
  padding: 18px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border: 1px solid #e2e8f0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

/* LEFT SIDE */
.summary-left {
  display: flex;
  flex-direction: column;
}

.summary-label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
}

.summary-value {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

/* RIGHT SIDE */
.summary-right {
  display: flex;
  flex-direction: column;
  min-width: 200px;
}

.summary-right label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 4px;
}

.summary-right select {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  background: #fff;
  font-weight: 600;
}

        /* MODAL */
        .modal-overlay { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 1rem; }
        .modal-content { background: #fff; width: 100%; max-width: 760px; border-radius: 16px; display: flex; flex-direction: column; max-height: 90vh; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25); }
        .modal-header { padding: 1.5rem 2rem; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: flex-start; }
        .meta-tag { background: #ecfdf5; color: #059669; font-size: 10px; font-weight: 800; text-transform: uppercase; padding: 2px 8px; border-radius: 99px; margin-bottom: 6px; display: inline-block; }
        .modal-header h2 { margin: 0; font-size: 1.15rem; font-weight: 800; }
        .btn-close { background: #f1f5f9; border: none; width: 28px; height: 28px; border-radius: 50%; font-size: 12px; cursor: pointer; }
        .modal-body { padding: 2rem; overflow-y: auto; }
        .sec-title { font-size: 11px; font-weight: 800; color: #2563eb; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 1.25rem; }
        .grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin-bottom: 2rem; }
        .grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem; }
        .fld-grp label { display: block; font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 6px; }
        .fld-grp input, .fld-grp select { width: 100%; padding: 10px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 13px; outline: none; }
        .player-card { background: #f8fafc; padding: 1.5rem; border-radius: 12px; border: 1px solid #f1f5f9; margin-bottom: 1.5rem; position: relative; }
        .sec-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; }
        .btn-add-text { background: none; border: none; color: #2563eb; font-weight: 700; font-size: 12px; cursor: pointer; }
        .btn-del-player { position: absolute; top: 1rem; right: 1rem; color: #ef4444; border: none; background: none; font-size: 11px; font-weight: 700; cursor: pointer; }
        .modal-footer { padding: 1.25rem 2rem; background: #fcfdfe; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; gap: 12px; }
        .btn-cancel { background: #fff; border: 1px solid #e2e8f0; padding: 10px 20px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; }
        .btn-save { background: #2563eb; color: #fff; border: none; padding: 10px 20px; border-radius: 8px; font-size: 13px; font-weight: 700; cursor: pointer; }
        .state-msg { text-align: center; padding: 4rem; color: #94a3b8; font-size: 13px; font-style: italic; }
      `}</style>
    </div>
  );
};

export default TournamentParticipants;